export enum SocketMessageTypes {
	WELCOME = 'welcome',
	CONFIRM_SUBSCRIPTION = 'confirm_subscription',
	PING = 'ping',
	PONG = 'pong',
	NEW_REQUEST = 'new_request',
	UPDATE = 'update',
	INIT = 'init',
	MESSAGE = 'message',
	SUBSCRIBE = 'subscribe',
	UNSUBSCRIBE = 'unsubscribe',
	SET_ID = 'set_id',
	NOTIFICATION = 'notification',
	CLOSE = 'close',
	UPDATE_DOCUMENTS = 'update_documents',
	NEED_RECONNECT = 'need_reconnect',
	LEAD_COMPLETE = 'lead_complete',
	LEAD_AGREEMENT_EXPIRED = 'lead_agreement_expired',
	MASS_UPDATE_FINISHED = 'mass_update_finished',
	ORGANIZATION_STATUS = 'organization_status',
	CONTRACT_STATUS = 'contract_status',
	CREATIVE_STATUS = 'creative_status',
	INVOICE_STATUS = 'invoice_status',
	EXTERNAL_FORM_MARK_AD = 'external_form_mark_ad',
	UPDATE_INFOTECS = 'update_infotecs',
	MASS_UPDATE_PARTNER = 'mass_update_partner',
	CHECK_LIMIT = 'check_limit',
	CHECK_STATUS = 'check_status',
	POST_REQUEST = 'post_request',
	UPDATE_REQUEST = 'update_request',
	CALCULATE_COMMISSION = 'calculate_commission',
	GET_BANK_DATA = 'get_bank_data',
	SAVE_NEW_SEND_ADDRESS = 'save_new_send_address',
	CLONE_REQUEST = 'clone_request',
	POST_LIMIT_REQUEST = 'post_limit_request',
	UPDATE_LIMIT_REQUEST = 'update_limit_request',
	LIMIT_INFO = 'limit_info',
	CURRENT_ELEMENTS = 'current_elements',
	SEND_TO_REWORK = 'send_to_rework',
	GET_GUARANTEE = 'get_guarantee',
	UNBLOCK_RELEASE = 'unblock_release',
	GET_CLIENT_LIMIT = 'get_client_limit',
	REQUEST_FIELDS_UPDATE = 'request_fields_update',
	CITIES_RESPONSE = 'cities_response',
	FIND_BY_DATE_RANGE_RESPONSE = 'find_by_date_range_response',
	CREATE_APPOINTMENT_RESPONSE = 'create_appointment_response',
	STATUS_RESPONSE = 'status_response',
	USER_LEAD_COMPLETE = 'user_lead_complete',
	REPORT_STATE_CHANGED = 'report_state_changed',
	MASS_UPDATE_LEADS_FINISHED = 'mass_update_leads_finished',
	CSAT_NOTIFICATION = 'csat_notification',
	GET_TEMPLATE = 'get_template',
	CREATE_APPOINTMENT_FOR_RBIDOS_RESPONSE = 'create_appointment_for_rbidos_response',
	SERVICE = 'service',
	NOTIFY = 'notify',
}
